import { createFileRoute } from "@tanstack/react-router"

import { WorkspacePage } from "~/components/design-system/pages"
import { TestRunPanel } from "~/components/ingestion-cockpit/TestRunPanel"

export const Route = createFileRoute("/_auth/ingestion-cockpit/_layout/data-checks")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <WorkspacePage>
      <TestRunPanel />
    </WorkspacePage>
  )
}
